import {Component, Vue} from "vue-property-decorator";
import Icon from "@/components/icon";

@Component
export default class UploaderPreviewDocument extends Vue {
  render(){
    return (
      <figure class="uploader-icon">
        <Icon icon="file" />
      </figure>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-11624eda/preview-document.tsx" });